const ruleFactory = (message, min, max) => {
  return { min, max, message };
};

export default ruleFactory;
